import React from "react";
import { alertConfig, alertConfigType } from "./alert.config";

import { Text } from "@fluentui/react-components";
import { threatConfig, ThreatType } from "../threat/threat.config";


export type AlertTypeChip = alertConfigType | ThreatType
type AlertChipProps = {
    type: AlertTypeChip;
    label: string;
    style?: React.CSSProperties;
    textStyle?: React.CSSProperties;
};


export const AlertChip = ({ type, label, style, textStyle }: AlertChipProps) => {
    const { icon: Icon, color, bgColor } = alertConfig[type] || threatConfig[type] || threatConfig.default;

    return (
        <div
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 5,
                background: bgColor,
                color,
                borderRadius: 6,
                padding: "4px 10px",
                fontWeight: 500,
                ...style,
            }}
        >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", }}>
                <Icon style={{ color, fontSize: 16 }} />
            </div>
            <Text size={200} style={{ color, ...textStyle }}>
                {label}
            </Text>
        </div>
    );
};
